import { useState } from 'react'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface RatingStarsProps {
  value?: number;
  isStatic?: boolean;
  onChange?: (val: number) => void;
}

export default function RatingStars (props: RatingStarsProps) {
  const { value = 0, isStatic = false, onChange } = props
  const [ hoverValue, setHoverValue ] = useState<number | null>(null)

  const handleClick = (index: number) => {
    if (isStatic || !onChange) return
    onChange(index + 1)
  }

  const handleMouseEnter = (index: number) => {
    if (isStatic) return
    setHoverValue(index + 1)
  }

  const handleMouseLeave = () => {
    if (isStatic) return
    setHoverValue(null)
  }

  return (
    <div className={styles.root}>
      <div className={styles.root__inner}>
        {Array.from({ length: 5 }).map((_, i) => {
          const isActive = hoverValue !== null ? i < hoverValue : i < value

          return (
            <span
              key={i}
              className={cn(styles.root__itemWrapper, {
                [styles.static]: isStatic,
              })}
              onClick={() => handleClick(i)}
              onMouseEnter={() => handleMouseEnter(i)}
              onMouseLeave={handleMouseLeave}
            >
              <ReactSVG
                className={cn(styles.root__item, {
                  [styles.active]: isActive,
                })}
                src="/icons/star-filled.svg"
                wrapper="span"
              />
            </span>
          )
        })}
      </div>
    </div>
  )
}
